/** @format */

import { RepaireRecordIssuedStatusMap } from '@/types/exception-management/dictionaries';
import frameWorkUtils from '@/utils/common';
import moment from 'moment';

export default function() {
  var utils = this.mixedUtils,
    _self = this,
    _org = this;

  const resObj = {
    adapterDataForViewModel: {
      //时间范围
      dateRangeHandler: {
        onChange(v) {
          console.log('date range outer change--:', v);
        },
        list: [
          {
            label: '日报',
            value: '00',
            compDefine: this.getCompDefineByCompName('span.aRangePicker'),
            model: '本周',
            defaultModel: '本周',
            group: ['昨天', '本周', '本月', '自定义'],
            onSyncMonthRangeValue: v => {
              console.log('day onSyncMonthRangeValue--:', v);
            },
            handleCustomChange: v => {
              console.log('handle custom chagne--:', v);
              this.filterParam.chkDayStart = _org.mixedUtils.formatDate(new Date(v[0][0]));
              this.filterParam.chkDayEnd = _org.mixedUtils.formatDate(new Date(v[0][1]));
            },
            onChange: (model, ...restArgs) => {
              console.log('restArgs--:', restArgs);
              // this.moment().add(-1, 'day')
              console.log('日报 on change---:', this.filterParam.type, model, this);
              if ('昨天' == model) {
                const yesterD = this.mixedUtils.formatDate(this.moment().add(-1, 'day')._d);
                this.filterParam.chkDayStart = yesterD;
                this.filterParam.chkDayEnd = yesterD;
                // this.filterParam.chkDayStart = yesterD + ' 00:00:00'
                // this.filterParam.chkDayEnd = yesterD + ' 23:59:59'
              }
              if ('本周' == model) {
                this.filterParam.chkDayEnd = utils.formatDate(
                  new Date(moment()
                    .week(moment().week())
                    .endOf('week') as any)
                );
                this.filterParam.chkDayStart = utils.formatDate(
                  new Date(moment()
                    .week(moment().week())
                    .startOf('week') as any)
                );
              }
              if ('本月' == model) {
                this.filterParam.chkDayEnd = utils.formatDate(
                  new Date(moment()
                    .month(moment().month())
                    .endOf('month') as any)
                );
                this.filterParam.chkDayStart = utils.formatDate(
                  new Date(moment()
                    .month(moment().month())
                    .startOf('month') as any)
                );
              }
              if ('自定义' == model) {
                this.filterParam.chkDayEnd = '';
                this.filterParam.chkDayStart = '';
              }
            }
          },
          {
            label: '月报',
            value: '01',
            model: '本月',
            defaultModel: '本月',
            compDefine: this.getCompDefineByCompName('span.monthRange'),
            group: ['本月', '上月', '近半年', '自定义'],
            onSyncMonthRangeValue: (v, ref) => {
              console.log('onSyncMonthRangeValue--:', v);
              this.filterParam.chkDayStart = v[0];
              this.filterParam.chkDayEnd = v[1];
              const calendarInstance = ref.$refs.picker.$refs.calendarInstance;
              // calendarInstance.clear()
              console.log('calendarInstance--:', calendarInstance);
            },
            handleCustomChange: v => {
              // console.log('handle custom chagne--:', v)
              // this.filterParam.chkDayStart = _org.mixedUtils
              //   .formatDate(new Date(v[0][0]))
              //   .split('-')
              //   .slice(0, 2)
              //   .join('-')
              // this.filterParam.chkDayEnd = _org.mixedUtils
              //   .formatDate(new Date(v[0][1]))
              //   .split('-')
              //   .slice(0, 2)
              //   .join('-')
            },
            onChange: model => {
              // this.moment().add(-1, 'day')
              console.log('月报 on change---:', this.filterParam.type, model, this);
              if ('本月' == model) {
                this.filterParam.chkDayStart = utils
                  .formatDate(
                    new Date(moment()
                      .month(moment().month())
                      .startOf('month') as any)
                  )
                  .split('-')
                  .slice(0, 2)
                  .join('-');
                this.filterParam.chkDayEnd = utils
                  .formatDate(
                    new Date(moment()
                      .month(moment().month())
                      .endOf('month') as any)
                  )
                  .split('-')
                  .slice(0, 2)
                  .join('-');
              }
              if ('上月' == model) {
                this.filterParam.chkDayStart = utils
                  .formatDate(
                    new Date(moment()
                      .month(moment().month() - 1)
                      .startOf('month') as any)
                  )
                  .split('-')
                  .slice(0, 2)
                  .join('-');
                this.filterParam.chkDayEnd = utils
                  .formatDate(
                    new Date(moment()
                      .month(moment().month() - 1)
                      .endOf('month') as any)
                  )
                  .split('-')
                  .slice(0, 2)
                  .join('-');
              }
              if ('近半年' == model) {
                this.filterParam.chkDayEnd = utils
                  .formatDate(
                    new Date(
                      moment().month(moment().month()) as any
                      // .endOf('month'),
                    )
                  )
                  .split('-')
                  .slice(0, 2)
                  .join('-');
                this.filterParam.chkDayStart = utils
                  .formatDate(
                    new Date(
                      moment().month(moment().month() - 6) as any
                      // .startOf('month'),
                    )
                  )
                  .split('-')
                  .slice(0, 2)
                  .join('-');
              }
              if ('自定义' == model) {
                this.filterParam.chkDayEnd = '';
                this.filterParam.chkDayStart = '';
              }
            }
          }
          // {
          //   label: '季报',
          //   value: '02',
          //   model: '本季度',
          //   defaultModel: '本季度',
          //   group: ['本季度', '上季度', '本年', '自定义'],
          //   onChange(v) {
          //     // this.moment().add(-1, 'day')
          //     console.log('季报 on change---:', v)
          //   },
          // },
          // {
          //   label: '年报',
          //   value: '03',
          //   model: '本年度',
          //   defaultModel: '本年度',
          //   group: ['本年度', '上年度', '自定义'],
          //   onChange(v) {
          //     // this.moment().add(-1, 'day')
          //     console.log('年报 on change---:', v)
          //   },
          // },
        ]
      },

      //下发状态
      repaireRecordIssuedStatusHandler: {
        list: frameWorkUtils.toLabelVal(RepaireRecordIssuedStatusMap),
        model: []
        // onChange: arr => {
        //   this.filterParam.liftCauses = arr.join(',')
        // },
      },
      releaseCausesHandler: {
        model: [],
        onChange: (arr: any[]) => {
          this.filterParam.releaseCauses = arr.join(',');
        }
      },
      reviewStatushandler: {
        model: [],
        onChange: (arr: any[]) => {
          this.filterParam.reviewStatus = arr.join(',');
        }
      },
      timeArrHandler: {
        model: [],
        // 入场时间改变
        onChange: (date: any, dateString: any) => {
          const [startTime, endTime] = dateString;
          this.filterParam.reviseStartTime = startTime;
          this.filterParam.reviseEndTime = endTime;
        }
      },
      // cleanTimeArrHandler: {
      //   model: [],
      //   // 入场时间改变
      //   onChange: (date: any, dateString: any) => {
      //     let [startTime, endTime] = dateString
      //     this.filterParam.cleanStartTime = startTime
      //     this.filterParam.cleanEndTime = endTime
      //   },
      // },

      plateModel: false
    },
    // stopDay: '', //停车：几天以上
    parkIds: [], // 车场ID集合,多车场逗号分隔
    plateHead: '', // 车牌头
    plateTail: '',
    org: [],
    type: '00', //默认日报
    //chkDayStart: this.mixedUtils.formatDate(this.moment().add(-1, 'day')._d), // 开始时间
    //chkDayEnd: this.mixedUtils.formatDate(this.moment().add(-1, 'day')._d), // 结束时间
    chkDayStart: this.mixedUtils.formatDate(
      new Date(moment()
        .week(moment().week())
        .startOf('week') as any)
    ),
    chkDayEnd: this.mixedUtils.formatDate(
      new Date(moment()
        .week(moment().week())
        .endOf('week') as any)
    ),
    releaseCauses: '', //放行原因
    status: '' //审核状态
    // cleanStartTime: '',
    // cleanEndTime: '',
    // authTypes: [], // 车辆类型,多个类型逗号分隔（00：临停小车 01：临停大车 02：产权车 03：月卡车）
    // carTypes: [], // 车型,多个类型逗号分隔,00：小车，01：大车
  };
  _self.selfBus.$on('B_TABLE_FILTER_CLEAR', () => {
    resObj.adapterDataForViewModel.dateRangeHandler.list[0].model = '本周';
    resObj.adapterDataForViewModel.dateRangeHandler.list[1].model = '本月';
  });
  return resObj;
}
